/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { OktaClient } from './OktaClient';

export class OktaStorage {

  public static clearAuthTokens() {
    OktaClient.tokenManager.clear();
    return OktaClient.signOut();
  }

  public static getAuthHeaderValue() {
    return 'Bearer ' + OktaStorage.getAccessToken();
  }

  public static supportRefreshToken() {
    return false;
  }

  public static getAccessToken() {
    return OktaClient.getAccessToken() ?? '';
  }

  public static setAuthTokens(_token: string, _refreshToken?: string) {}
  public static getRefreshToken() {
    return '';
  }
}
